import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { RenderProductPricesModule } from 'render/render-shared/ui/render-product-prices/render-product-prices.module';
import { RenderProductPurchaseOptionsModule } from 'render/render-shared/ui/render-product-sizes/render-product-purchase-options.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';
import { SwiperModule } from 'swiper/angular';

import { PieceProductRenderComponent } from './piece-product-render.component';


export const pieceProductRenderModuleEntryComponents = [
  PieceProductRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    SwiperModule,
    RenderSharedModule,
    RenderBlocksModule,
    LazyLoadModule,
    RenderProductPricesModule,
    RenderProductPurchaseOptionsModule
  ],
  declarations: pieceProductRenderModuleEntryComponents
})
export class PieceProductRenderModule {}

export default pieceProductRenderModuleEntryComponents;
